import { useState } from 'react'
import AuthorityProjects from './Tabs/AuthorityProjects'
import { AllProjects } from '../Projects/Tabs/AllProjects'
import FlipCardShowcase from './Cards/FlipCardShowcase';
// import {designdata} from '../Projects/Tabs/DesignprojectsData'
// import {dprdata} from '../Projects/Tabs/DPRprojectData'
// import {FRdata} from '../Projects/Tabs/FeasibilityReport'
// import {Supervisiondata} from '../Projects/Tabs/Supervision'
// import {OMdata} from '../Projects/Tabs/OperationsMaintenance'
// import {IEdata} from '../Projects/Tabs/IndependentEngineer'

const FilterServices = () => {
    const [toggleState, setToggleState] = useState(1);

    return (
        <div className='max-sm:py-10 relative flex items-start justify-center overflow-hidden py-20'>
            <div className='max-sm:px-6 w-full md:max-xl:px-6 flex flex-col items-center gap-6 md:gap-12 px-14'>
                <div className='w-auto md:w-[60%] overflow-x-scroll  md:pr-4 rounded-full'>
                    <div className="overflow-x-scroll justify-center items-center flex   all-project">
                        <button
                            className={`text-4xl font-bold`}
                        >
                           Key <span className='purple'>Projects</span>
                        </button>

                        
                    </div>
                </div>
                <div className='filterservicebgright '></div>
                <div className='filterservicebgleft'></div>
                <div className="w-full px-0 xl:px-4">
                    {toggleState === 1 ? <FlipCardShowcase /> : null}
                    {/* {toggleState === 1 ? <AuthorityProjects data={AllProjects} /> : null} */}
                    {toggleState === 2 ? <AuthorityProjects data={AllProjects} /> : null}
                   
                </div>
            </div>
        </div>
    )
}

export default FilterServices